var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpressway = function SvgExpressway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m.646 6.646-.055.066A.5.5 0 0 0 1 7.5h3.5V13a.5.5 0 0 0 .5.5h4l.09-.008A.5.5 0 0 0 9.5 13V7.5H13a.5.5 0 0 0 .354-.854l-6-6a.5.5 0 0 0-.708 0z"
  })));
};
export default SvgExpressway;